import { Text, VStack } from '@chakra-ui/react';

import type { TContentCreatorApplicationSummary } from '@/services/api/requests/contentCreatorApplications';
import ApplicantApplicationInfoCard from './ApplicantApplicationInfoCard';

const PendingApplicationDetails = ({ application }: { application: TContentCreatorApplicationSummary }) => {
  return (
    <VStack minHeight={'100vh'} width={'100vw'} paddingX={'24px'} paddingY={'120px'} spacing={'24px'}>
      <VStack spacing={'10px'} maxWidth={'620px'}>
        <Text
          variant={'loraTitle'}
          color={'white'}
          fontSize={'26px'}
          lineHeight={'32px'}
          fontWeight={'400'}
          textAlign={'center'}
        >
          Application Pending
        </Text>
        <Text
          color={'white'}
          fontSize={'16px'}
          fontWeight={'500'}
          lineHeight={'22px'}
          textAlign={'center'}
          opacity={0.85}
        >
          Your content creator application is under review.
        </Text>

        <Text
          color={'white'}
          fontSize={'16px'}
          fontWeight={'500'}
          lineHeight={'22px'}
          textAlign={'center'}
          opacity={0.85}
        >
          You can find your submitted application details below.
        </Text>
      </VStack>

      <ApplicantApplicationInfoCard
        application={application}
        dateLabel={'SUBMITTED DATE'}
        dateValue={application.submittedAt}
      />
    </VStack>
  );
};

export default PendingApplicationDetails;
